import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
// Import API service first to register global axios interceptors before any other imports
import './services/api';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
